import React from 'react';
import HeaderCarousel from '../components/Home/HeaderCarousel';
import { Link } from 'react-router-dom';
import { buildWhatsAppLink, WHATSAPP_LINK } from '../constants';
import img1 from '../assets/images/carousel-1.jpg';
import img2 from '../assets/images/carousel-2.jpg';
import img3 from '../assets/images/carousel-3.jpg';
import img4 from '../assets/images/carousel-4.jpg';

// Imagens dos produtos em destaque
import pedrasNaturaisImg from '../assets/images/ciacollos-pedras-naturais.jpg';
import tintaSprayImg from '../assets/images/killing-tinta-spray.jpg';
import kisacrilImg from '../assets/images/killing-kisacril-ultrafosco.jpg';

const highlights = [
  {
   icon: 'fa-paint-roller',
   title: 'Tintas premium',
   text: 'Produtos com acabamento impecável para ambientes residenciais e comerciais.',
  },
  {
   icon: 'fa-shield-alt',
   title: 'Durabilidade',
   text: 'Formulações pensadas para resistência, brilho e longa vida útil.',
  },
  {
   icon: 'fa-user-tie',
   title: 'Atendimento especializado',
   text: 'Nossa equipe orienta a escolha ideal para seu projeto e orçamento.',
  },
];

const productsPreview = [
  {
   name: 'Revestimento Pedras Naturais',
   text: 'Efeito de pedra natural para transformar seus ambientes!',
   image: pedrasNaturaisImg,
  },
  {
   name: 'Tinta Spray Uso Geral Killing',
   text: 'Praticidade e acabamento profissional para qualquer superfície.',
   image: tintaSprayImg,
  },
  {
   name: 'Tinta Acrílica Killing Kisacril',
   text: 'Qualidade que faz a diferença no acabamento!',
   image: kisacrilImg,
  },
];

const HomePage = () => {
  return (
   <>
     <HeaderCarousel />

     <div className="container-fluid py-5 bg-light">
       <div className="container">
         <div className="row g-4 align-items-center">
           <div className="col-lg-5">
             <span className="eyebrow">A marca certa para reformar com confiança</span>
             <h2 className="display-6 fw-bold mb-3">Mais de 10 anos entregando beleza e proteção para seus ambientes.</h2>
             <p className="text-muted mb-4">
               Na Mafra Tintas, desenvolvemos soluções para transformar espaços com qualidade,
               acabamento refinado e atendimento que entende suas necessidades.
             </p>
             <div className="d-flex flex-wrap gap-3">
               <Link to="/produtos" className="btn btn-primary py-3 px-4">Ver produtos</Link>
               <a href={WHATSAPP_LINK} className="btn btn-outline-primary py-3 px-4" target="_blank" rel="noreferrer">
                 Fale conosco
               </a>
             </div>
           </div>
           <div className="col-lg-7">
             <div className="row g-4">
               {highlights.map((item) => (
                 <div className="col-md-4" key={item.title}>
                   <div className="feature-box h-100">
                     <div className="feature-box__icon">
                       <i className={`fas ${item.icon}`} />
                     </div>
                     <h4>{item.title}</h4>
                     <p>{item.text}</p>
                   </div>
                 </div>
               ))}
             </div>
           </div>
         </div>
       </div>
     </div>

     <div className="container py-5">
       <div className="section-heading text-center mb-5">
         <span className="eyebrow">Categorias</span>
         <h2>Produtos que atendem diferentes projetos e necessidades.</h2>
       </div>

       <div className="row g-4">
         <div className="col-lg-3 col-md-6">
           <div className="category-card">
             <img src={img1} alt="Tintas para interiores" />
             <div className="category-card__content">
               <h4>Residencial</h4>
               <p>Ambientes com conforto, beleza e acabamento refinado.</p>
             </div>
           </div>
         </div>
         <div className="col-lg-3 col-md-6">
           <div className="category-card">
             <img src={img2} alt="Tintas para comerciais" />
             <div className="category-card__content">
               <h4>Comercial</h4>
               <p>Soluções para espaços que exigem durabilidade e impacto visual.</p>
             </div>
           </div>
         </div>
         <div className="col-lg-3 col-md-6">
           <div className="category-card">
             <img src={img3} alt="Tintas industriais" />
             <div className="category-card__content">
               <h4>Industrial</h4>
               <p>Proteção e resistência em aplicações de alta demanda.</p>
             </div>
           </div>
         </div>
         <div className="col-lg-3 col-md-6">
           <div className="category-card">
             <img src={img4} alt="Tintas para consultoria" />
             <div className="category-card__content">
               <h4>Consultoria</h4>
               <p>Orientação técnica para escolher o produto ideal para cada projeto.</p>
             </div>
           </div>
         </div>
       </div>
     </div>

     <div className="container-fluid py-5 bg-dark-surface">
       <div className="container">
         <div className="section-heading text-center mb-5 text-white">
           <span className="eyebrow eyebrow-light">Produtos em destaque</span>
           <h2 className="text-white">Opções selecionadas para atender projetos com excelência.</h2>
           <p className="text-white-50 mt-3">
             A <a href="https://www.instagram.com/tintaskilling/" target="_blank" rel="noreferrer" className="text-white fw-semibold text-decoration-underline">Tintas Killing</a> também faz parte da nossa história.
           </p>
         </div>

         <div className="row g-4">
           {productsPreview.map((product) => (
             <div className="col-lg-4" key={product.name}>
               <div className="product-mini-card h-100">
                 <img
                   src={product.image}
                   alt={product.name}
                   className="product-mini-card__image mb-3"
                 />
                 <div className="product-mini-card__header">
                   <span>Popular</span>
                 </div>
                 <h3>{product.name}</h3>
                 <p>{product.text}</p>
                 <a href={buildWhatsAppLink(product.name)} className="btn btn-primary mt-3" target="_blank" rel="noreferrer">
                   Comprar
                 </a>
               </div>
             </div>
           ))}
         </div>
       </div>
     </div>

     <div className="container py-5">
       <div className="row g-4 align-items-center">
         <div className="col-lg-6">
           <div className="process-card">
             <span className="eyebrow">Como trabalhamos</span>
             <h2>Uma experiência simples e segura do início ao fim.</h2>
             <ul className="process-list">
               <li>
                 <span>1</span>
                 <div>
                   <strong>Consulta inicial</strong>
                   <p>Entendemos seu objetivo, espaço e necessidade do projeto.</p>
                 </div>
               </li>
               <li>
                 <span>2</span>
                 <div>
                   <strong>Indicação técnica</strong>
                   <p>Recomendamos a melhor tinta e acabamento para o resultado desejado.</p>
                 </div>
               </li>
               <li>
                 <span>3</span>
                 <div>
                   <strong>Entrega e compra</strong>
                   <p>Você recebe o suporte necessário para finalizar a compra com praticidade.</p>
                 </div>
               </li>
             </ul>
           </div>
         </div>
         <div className="col-lg-6">
           <div className="cta-panel">
             <span className="eyebrow eyebrow-dark">Atendimento rápido</span>
             <h3>Seu próximo projeto merece uma solução profissional.</h3>
             <p>
               Fale com a nossa equipe e receba orientação para escolher o produto ideal para suas paredes,
               superfície ou aplicação industrial.
             </p>
             <a href={WHATSAPP_LINK} className="btn btn-primary py-3 px-4" target="_blank" rel="noreferrer">
               Solicitar atendimento
             </a>
           </div>
         </div>
       </div>
     </div>
   </>
  );
};

export default HomePage;